import $api from '../config/api'

export const getThemes = async () => {
  const response = await $api.get('/themes')
  return response.data
}
